import { render } from "./TSVGruss.vue?vue&type=template&id=69b35192"
const script = {}

import exportComponent from "C:\\Users\\Alexander\\Documents\\Hompage TT Tools\\TT Homapge Files\\Webseite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__